export const defaultSalesSource = 'lead';
